import Head from 'next/head';
import { Inter } from 'next/font/google';
import styles from '@/styles/Home.module.css';

const inter = Inter({ subsets: ['latin'] });

export default function Home() {
  return (
    <>
      <Head>
        <title>404 Not found!</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charset="utf-8" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className={styles.wrapper}>
        <h1 className={styles.header}>404</h1>
        <h3 className={styles.subheader}>Not Found</h3>
        <p className={styles.text}>The resource requested cannot be found on this server!</p>
      </div>
    </>
  );
}
